export default {"src":"/_next/static/media/AIG.b2fbc4a4.svg","height":18,"width":18};